import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../Library.mjs';
import {
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
} from '../js/coreRuntime.mjs';
import { AbstractSet2mw1ev10zm1bz as AbstractSet } from './AbstractSet.mjs';
import { AbstractCollection1g9uvtcheckwb as AbstractCollection } from './AbstractCollection.mjs';
import {
  Collection1k04j3hzsbod0 as Collection,
  Entry2xmjmyutzoq3p as Entry,
  KtMap140uvy3s5zad8 as KtMap,
} from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../hacks.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from './_Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractMap$keys$1$iterator$1Class;
function AbstractMap$keys$1$iterator$1() {
  if (AbstractMap$keys$1$iterator$1Class === VOID) {
    class $ {
      constructor($entryIterator) {
        this.$entryIterator_1 = $entryIterator;
      }
      hasNext_bitz1p_k$() {
        return this.$entryIterator_1.hasNext_bitz1p_k$();
      }
      next_20eer_k$() {
        return this.$entryIterator_1.next_20eer_k$().get_key_18j28a_k$();
      }
    }
    initMetadataForClass($);
    AbstractMap$keys$1$iterator$1Class = $;
  }
  return AbstractMap$keys$1$iterator$1Class;
}
var AbstractMap$values$1$iterator$1Class;
function AbstractMap$values$1$iterator$1() {
  if (AbstractMap$values$1$iterator$1Class === VOID) {
    class $ {
      constructor($entryIterator) {
        this.$entryIterator_1 = $entryIterator;
      }
      hasNext_bitz1p_k$() {
        return this.$entryIterator_1.hasNext_bitz1p_k$();
      }
      next_20eer_k$() {
        return this.$entryIterator_1.next_20eer_k$().get_value_j01efc_k$();
      }
    }
    initMetadataForClass($);
    AbstractMap$values$1$iterator$1Class = $;
  }
  return AbstractMap$values$1$iterator$1Class;
}
function toString_0($this, entry) {
  return toString_1($this, entry.get_key_18j28a_k$()) + '=' + toString_1($this, entry.get_value_j01efc_k$());
}
function toString_1($this, o) {
  return o === $this ? '(this Map)' : toString(o);
}
function implFindEntry($this, key) {
  var tmp0 = $this.get_entries_p20ztl_k$();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (equals(element.get_key_18j28a_k$(), key)) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var AbstractMap$keys$1Class;
function AbstractMap$keys$1() {
  if (AbstractMap$keys$1Class === VOID) {
    class $ extends AbstractSet() {
      constructor(this$0) {
        return new.target.new_kotlin_collections_AbstractMap__no_name_provided__tjdmmj_k$(this$0);
      }
      static new_kotlin_collections_AbstractMap__no_name_provided__tjdmmj_k$(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.this$0__1 = this$0;
        return this.new_kotlin_collections_AbstractSet_l10baj_k$($box);
      }
      contains_vbgn2f_k$(element) {
        return this.this$0__1.containsKey_aw81wo_k$(element);
      }
      contains_aljjnj_k$(element) {
        if (!true)
          return false;
        return this.contains_vbgn2f_k$(element);
      }
      iterator_jk1svi_k$() {
        var entryIterator = this.this$0__1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
        return new (AbstractMap$keys$1$iterator$1())(entryIterator);
      }
      get_size_woubt6_k$() {
        return this.this$0__1.get_size_woubt6_k$();
      }
    }
    initMetadataForClass($);
    AbstractMap$keys$1Class = $;
  }
  return AbstractMap$keys$1Class;
}
var AbstractMap$values$1Class;
function AbstractMap$values$1() {
  if (AbstractMap$values$1Class === VOID) {
    class $ extends AbstractCollection() {
      constructor(this$0) {
        return new.target.new_kotlin_collections_AbstractMap__no_name_provided__g3sttz_k$(this$0);
      }
      static new_kotlin_collections_AbstractMap__no_name_provided__g3sttz_k$(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.this$0__1 = this$0;
        return this.new_kotlin_collections_AbstractCollection_s1tlv0_k$($box);
      }
      contains_m22g8e_k$(element) {
        return this.this$0__1.containsValue_yf2ykl_k$(element);
      }
      contains_aljjnj_k$(element) {
        if (!true)
          return false;
        return this.contains_m22g8e_k$(element);
      }
      iterator_jk1svi_k$() {
        var entryIterator = this.this$0__1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
        return new (AbstractMap$values$1$iterator$1())(entryIterator);
      }
      get_size_woubt6_k$() {
        return this.this$0__1.get_size_woubt6_k$();
      }
    }
    initMetadataForClass($);
    AbstractMap$values$1Class = $;
  }
  return AbstractMap$values$1Class;
}
var AbstractMapClass;
function AbstractMap() {
  if (AbstractMapClass === VOID) {
    class $ {
      static new_kotlin_collections_AbstractMap_5v98o7_k$() {
        var $this = createThis(this);
        $this._keys_1 = null;
        $this._values_1 = null;
        return $this;
      }
      containsKey_aw81wo_k$(key) {
        return !(implFindEntry(this, key) == null);
      }
      containsValue_yf2ykl_k$(value) {
        var tmp0 = this.get_entries_p20ztl_k$();
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.isEmpty_y1axqb_k$();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (equals(element.get_value_j01efc_k$(), value)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        return tmp$ret$0;
      }
      containsEntry_50dpfo_k$(entry) {
        if (!(!(entry == null) ? isInterface(entry, Entry()) : false))
          return false;
        var key = entry.get_key_18j28a_k$();
        var value = entry.get_value_j01efc_k$();
        // Inline function 'kotlin.collections.get' call
        var ourValue = (isInterface(this, KtMap()) ? this : THROW_CCE()).get_wei43m_k$(key);
        if (!equals(value, ourValue)) {
          return false;
        }
        var tmp;
        if (ourValue == null) {
          // Inline function 'kotlin.collections.containsKey' call
          tmp = !(isInterface(this, KtMap()) ? this : THROW_CCE()).containsKey_aw81wo_k$(key);
        } else {
          tmp = false;
        }
        if (tmp) {
          return false;
        }
        return true;
      }
      equals(other) {
        if (other === this)
          return true;
        if (!(!(other == null) ? isInterface(other, KtMap()) : false))
          return false;
        if (!(this.get_size_woubt6_k$() === other.get_size_woubt6_k$()))
          return false;
        var tmp0 = other.get_entries_p20ztl_k$();
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.isEmpty_y1axqb_k$();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (!this.containsEntry_50dpfo_k$(element)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      get_wei43m_k$(key) {
        var tmp0_safe_receiver = implFindEntry(this, key);
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_value_j01efc_k$();
      }
      hashCode() {
        return hashCode(this.get_entries_p20ztl_k$());
      }
      isEmpty_y1axqb_k$() {
        return this.get_size_woubt6_k$() === 0;
      }
      get_size_woubt6_k$() {
        return this.get_entries_p20ztl_k$().get_size_woubt6_k$();
      }
      get_keys_wop4xp_k$() {
        if (this._keys_1 == null) {
          var tmp = this;
          tmp._keys_1 = AbstractMap$keys$1().new_kotlin_collections_AbstractMap__no_name_provided__tjdmmj_k$(this);
        }
        return ensureNotNull(this._keys_1);
      }
      toString() {
        var tmp = this.get_entries_p20ztl_k$();
        return joinToString(tmp, ', ', '{', '}', VOID, VOID, (it) => toString_0(this, it));
      }
      get_values_ksazhn_k$() {
        if (this._values_1 == null) {
          var tmp = this;
          tmp._values_1 = AbstractMap$values$1().new_kotlin_collections_AbstractMap__no_name_provided__g3sttz_k$(this);
        }
        return ensureNotNull(this._values_1);
      }
    }
    initMetadataForClass($, 'AbstractMap', VOID, VOID, [KtMap()]);
    AbstractMapClass = $;
  }
  return AbstractMapClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  AbstractMap as AbstractMap3sqd8xvg0030s,
};
//endregion

//# sourceMappingURL=AbstractMap.mjs.map
